import { useQuery } from "@tanstack/react-query";
import Drawer from "../../../../drawer/Drawer";
import EventDetails from "../EventDetails";
import { eventDetails } from "../../../../../services/eventService";
import { lngDetect } from "../../../../../helpers/lngDetect";
import { t } from "i18next";

const EventDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  const { data: details } = useQuery({
    queryKey: ["details", data?.uid],
    queryFn: async () => {
      const res = await eventDetails({ id: data?.uid, type: "front" });
      return res;
    },
    enabled: !!data?.uid,
  });

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl6"}
      size={"xl6"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          {lngDetect(details?.data?.title)}
        </span>
      }
      subtitle={t("View information bellow")}
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-auto scrollbar flex bg-gradient-to-tr from-[#f5faff] via-white to-[#fef6f9]"
    >
      <div className="">
        <EventDetails data={details?.data} />
      </div>
    </Drawer>
  );
};

export default EventDetailsDrawer;
